

const AboutChamaFlow = () => (
  <section className="py-16 px-6 bg-white text-center">
    <div className="max-w-4xl mx-auto">
      <h2 className="text-3xl font-semibold mb-4">What is ChamaFlow?</h2>
      <p className="text-lg text-gray-700 leading-relaxed">
        ChamaFlow is a purpose-built desktop application that empowers grassroots financial groups, Chamas, and MFIs to digitize their operations and manage all group activities with ease. Whether you’re a solo user, a team, or a growing enterprise, ChamaFlow has a version tailored to your needs.
      </p>
  
    </div>

    
  </section>
);

export default AboutChamaFlow;

